import React from 'react';
import PropTypes from 'prop-types';

import DiscountCoupon from 'assets/images/general/discount-coupon.svg';
import style from './AdditionalPromo.module.scss';

const AdditionalPromo = ({ isPromoApplied = false, onApplyPromo = () => { }, roundedBtn = false }) => {
    const addPromoCode = () => {
        if (!isPromoApplied) {
            onApplyPromo();
        }
    };

    const getBtnStyles = () => {
        return [
            style.additionalPromo__btn,
            isPromoApplied ? style.additionalPromo__btn_promo_added : style.additionalPromo__btn_add_promo,
            roundedBtn ? style.additionalPromo__btn_rounded : ''
        ].filter(Boolean).join(' ');
    };

    const getBtnText = () => {
        if (!isPromoApplied) {
            return 'Add Promotion';
        }

        return 'Promotion Added';
    };

    return (
        <div className={style.additionalPromo}>
            <div className='d-flex'>
                <img src={DiscountCoupon} alt='Discount coupon' className={style.additionalPromo__icon} />
                <span className={style.additionalPromo__text}>20% OFF: Galaxy Z Series</span>
            </div>
            <button className={getBtnStyles()} onClick={addPromoCode}>{ getBtnText() }</button>
        </div>
    );
};

AdditionalPromo.propTypes = {
    isPromoApplied: PropTypes.bool,
    onApplyPromo: PropTypes.func,
    roundedBtn: PropTypes.bool
};

export default AdditionalPromo;
